/**
 * One Escape press is two events: `keydown` and, on release, `keyup`.
 *
 * A Modal closes on the keydown. By the time the keyup arrives the Modal is gone, and anything
 * else listening for Escape on keyup sees a press it should never have seen. The Brushaway panel
 * (the IP Assistant widget) closes on exactly that keyup, so one Escape used to close the modal
 * AND the whole widget behind it.
 *
 * So when a Modal consumes an Escape keydown, it also swallows the keyup that completes the same
 * press: a one-shot capture-phase listener that outlives the Modal, stops the event reaching
 * anything else, and removes itself. The NEXT Escape reaches everything normally.
 */
/** A keyup that never comes (key released outside the window) must not leave the listener behind. */
const SWALLOW_TIMEOUT_MS = 1000;
export function swallowNextEscapeKeyUp() {
    let timer = null;
    const cleanup = () => {
        window.removeEventListener('keyup', handler, true); // eslint-disable-line @typescript-eslint/no-use-before-define
        if (timer !== null)
            clearTimeout(timer);
    };
    function handler(event) {
        if (event.key !== 'Escape')
            return;
        event.stopPropagation();
        event.preventDefault();
        cleanup();
    }
    window.addEventListener('keyup', handler, true);
    timer = setTimeout(cleanup, SWALLOW_TIMEOUT_MS);
}
